import { Container, Screen1, Screen2, Screen3, Tag } from './styled';
import ArrowBack from '../../../components/ArrowBack'
import { Calendar } from '../../../components/Calendar'
import { useState, useEffect } from 'react';
import StyledSelect from '../../../components/Select';
import Input from "../../../components/Input/InputSignUp";
import MaskInput from "../../../components/Input/MaskInput";
import { FaPhone } from "react-icons/fa";
import Button from '../../../components/Button';
import { addDays } from 'date-fns';
import RoomCard from '../../../components/RoomCard';
import { useParams } from 'react-router-dom';
import { api } from '../../../services/api';
import { useUserContext } from "../../../components/contexts/useUserContext";
import CarouselImage from '../../../components/CarouselImage';

const Destination4 = () => {
    const {id} = useParams();
    const placeholder = "https://patriciaelias.com.br/wp-content/uploads/2021/01/placeholder.png"
    const { user } = useUserContext();

    const [name, setName] = useState("");
    const [cpf, setCpf] = useState("");
    const [ddd, setDdd] = useState("");
    const [number, setNumber] = useState("");
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedRoom, setSelectedRoom] = useState(0);
    const [adults, setAdults] = useState({value: 1, label: "1 adulto"});
    const [kids, setKids] = useState({value: 0, label: `Nenhuma Criança (até 12 anos)`});
    const [adultsOptions, setAdultsOptions] = useState([]);
    const [kidsOptions, setKidsOptions] = useState([]);
    const [bookerIsUser, setBookerIsUser] = useState(false);

    const [hotel, setHotel] = useState({
        cep: null, street: null, street_number: null, 
        neighborhood: null, images_url: [], classification: null,
        tags: [], name: null, category: {name: null}, 
        description: null, room_types: [], link_maps: null
    });

    const [datas, setDatas] = useState([{
        startDate: new Date(),
        endDate: addDays(new Date(), 1),
        key: 'selection'
    }]);

    const formatDate = (dateInput) => {
        let d = new Date(dateInput)
        let ye = new Intl.DateTimeFormat('pt-br', { year: 'numeric' }).format(d);
        let mo = new Intl.DateTimeFormat('pt-br', { month: 'long' }).format(d);
        let da = new Intl.DateTimeFormat('pt-br', { day: '2-digit' }).format(d);
        return(`${da} de ${mo} de ${ye}`);
    }

    const daysDiff = (startDate, endDate) => {
        var msDiff =  endDate.getTime() - startDate.getTime();    //Future date - current date
        return Math.floor(msDiff / (1000 * 60 * 60 * 24)) + 1;
    }

    useEffect(() => {
        api.get(`/hotels/show/${id}`)
        .then(response => {
            setHotel(response.data);
            let max = 1;
            response.data.room_types?.forEach((roomType) => {
                if(roomType.capacity > max)
                    max = roomType.capacity;
            })
            let adultsCapacity = [{value: 1, label: "1 adulto"}];
            let kidsCapacity = [{value: 0, label: `Nenhuma Criança (até 12 anos)`}, {value: 1, label: "1 criança (até 12 anos)"}];
            for (let i = 2; i <= max; i++){
                adultsCapacity.push({value: i, label: `${i} adultos`});
                kidsCapacity.push({value: i, label: `${i} Crianças (até 12 anos)`});
            }
            setAdultsOptions(adultsCapacity);
            setKidsOptions(kidsCapacity);

        })
    }, [id])

    useEffect(() => {
        if (bookerIsUser){
            setCpf(user.cpf);
            setName(user.name);
            setDdd(user.ddd);
            setNumber(user.phone);
        }
    }, [bookerIsUser, user])

    const checkCapacity = (value) => {
        if (value.capacity >= adults.value)
            return value;
    }

    return (
        <Container>
            <ArrowBack />
            <Screen1>
                <div>
                    <div className="images">
                        <CarouselImage request="hotels" id={id} placeholder={placeholder}/>
                    </div>
                    <h3>Detalhes da Hospedagem</h3>
                    <p>
                        <b>CEP: </b>
                        {hotel.cep}
                    </p>
                    <p>
                        <b>Rua: </b>
                        {hotel.street}
                    </p>
                    <p>
                        <b>Número: </b>
                        {hotel.street_number}
                    </p>
                    <p>
                        <b>Bairro: </b>
                        {hotel.neighborhood}
                    </p>
                    
                    <p>
                        <b>Classificação: </b>
                        {hotel.classification || "Este hotel ainda não foi avaliado."}
                    </p>
                    <div className="tags">
                        {hotel.tags.map((tag, index) => {
                            return <Tag key={index}>{tag.name}</Tag>
                        })}
                    </div>
                </div>
                <div>
                    <h2>{hotel.name}</h2>
                    <h6>{hotel.category?.name}</h6>
                    <p>{hotel.description}</p>
                </div>
            </Screen1>
            <Screen2>
                <h3>Faça sua solicitação de reserva <br/> em {hotel.name}</h3>
                <div className="select-options">
                    <div>
                        <h5>Data de Estadia</h5>
                        <div className="select-date">
                            <div onClick={() => setShowCalendar(!showCalendar)} >
                                <StyledSelect isSearchable={false} isDisabled
                                    placeholder={daysDiff(datas[0].startDate, datas[0].endDate) > 1 ?
                                        `${formatDate(datas[0].startDate)} - ${formatDate(datas[0].endDate)}` :
                                        formatDate(datas[0].startDate)}
                                />
                            </div>
                            {showCalendar && <Calendar months={2} className="my-calendar"
                                direction="horizontal" state={datas} setState={setDatas} minDate={new Date()}
                            />}
                        </div>
                    </div>
                    <div>
                        <h5>Número de Hóspedes</h5>
                        <div className="select-inputs">
                            <StyledSelect placeholder="Adultos" isClearable={false} isSearchable={false}
                                options={adultsOptions} value={adults} onChange={value => setAdults(value)}
                            />
                            <StyledSelect placeholder="Crianças (até 12 anos)" isClearable={false} isSearchable={false}
                                options={kidsOptions} value={kids} onChange={value => setKids(value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="room-cards">
                    {hotel.room_types.filter(checkCapacity).map((roomType, index) => {
                        return <RoomCard key={index} selected={selectedRoom === roomType.id ? true : false}
                            setSelectedRoom={setSelectedRoom} id={roomType.id} name={roomType.name} 
                            capacity={roomType.capacity} description={roomType.description}
                            images={roomType.images_url}
                        />
                    })}
                </div>
                <div>
                    <input type='checkbox' className='checkbox' id='checkbox' value={bookerIsUser} onChange={() => setBookerIsUser(!bookerIsUser)}/>
                    <label for='checkbox' className='label'>Reservar no Nome de {user?.name}</label>
                </div>
                <div className="booker-data">   
                    <h5>Digite os dados do portador da Reserva</h5>
                    <form>
                        <div className="input-line">
                            <Input
                                placeholder="Nome Completo"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                format='full_name'
                                required
                            />
                        </div>
                        <div className="phone-inputs input-line">
                            <MaskInput
                                mask='(99)'
                                placeholder='DDD'
                                name='ddd'
                                value={ddd} onChange={(e)=>setDdd(e.target.value)}
                                format='ddd'
                                required
                            />
                            <MaskInput
                                mask="99999-9999"
                                value={number}
                                onChange={(e) => setNumber(e.target.value)}
                                placeholder="Telefone"
                                Icon={FaPhone}
                                format="phone"
                                required
                            />
                        </div>
                        <div className="input-line">
                            <MaskInput
                                mask="999.999.999-99"
                                value={cpf}
                                onChange={(e) => setCpf(e.target.value)}
                                required
                                placeholder="CPF"
                            />
                        </div>
                    </form>
                </div>
                <div className="confirmation">
                    <h4>
                        Estadia total
                        <span>{daysDiff(datas[0].startDate, datas[0].endDate)} diárias</span>
                    </h4>
                    <Button format="home">Quero Ir de Férias!</Button>
                </div>
            </Screen2>
            <Screen3>
                <h3>Como chegar</h3>
                <iframe title="Localização" src={hotel.link_maps} style={{border: '0', width: '53rem', height: '40rem'}} allowFullScreen loading="lazy"></iframe>
            </Screen3>
        </Container>
        
    );
}

export default Destination4;